import { BaseEntity } from "yt-ng-framework";

export class TipKomitenta extends BaseEntity {
    constructor(){
        super();
    }

    Naziv: string = null;
    GenericName: string = null;

    Deserialize(input: any){
        this.ID = input.ID;
        this.Naziv = input.Naziv;
        this.GenericName = input.GenericName;
        return this;
    }

    Serialize(input: TipKomitenta){
        return input;
    }

}